import { Box, Grid, Typography, useTheme } from "@material-ui/core";
import React from "react";
import { ThemedAsset, assetIds } from "nemuru-components";
import MainButton from "../../../../shared/components/MainButton";
import Text from "../../../../shared/components/Text";

export const VideoIdErrorMessage = ({ repeatVideoId }) => {
  const { palette } = useTheme();
  return (
    <>
      <Box
        mt={4}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        className="appear-anim"
      >
        <ThemedAsset
          id={assetIds.ICON_FAIL}
          width={50}
          height={50}
          style={{ color: palette.error.main }}
        />
        <Grid
          container
          display="flex"
          direction="column"
          alignItems="center"
          justifyContent="center"
          style={{ paddingTop: 20 }}
        >
          <Typography
            color={palette.text.title}
            variant={"h6"}
            className={"mb-4 transition-all"}
          >
            <strong>
              <Text tId={"OOPS"} />
            </strong>
          </Typography>
          <Typography
            variant={"body2"}
            className={"mb-3 transition-all"}
            style={{
              color: palette.text.primary,
              textAlign: "center",
            }}
          >
            <Text tId={"AN_ERROR_OCURRED_DURING_THE_VIDEO_ID"} />
          </Typography>
          <Typography
            variant={"body2"}
            className={"mb-3 transition-all"}
            style={{
              color: palette.text.primary,
              textAlign: "center",
            }}
          >
            <Text tId={"PLEASE_TRY_AGAIN"} />
          </Typography>
        </Grid>
      </Box>
      <Box />
      <MainButton onClick={repeatVideoId}>
        <Text tId={"REPEAT_VIDEO_ID"} />
      </MainButton>
    </>
  );
};
